import alertMessage from './alertMessage';
import auth from './auth';
import dateUtil from './dateUtil';
import { downloadFile } from './download';
import { http } from './http';
import { isArray } from 'lodash';

const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) { return pair[1]; }
    }
    return (false);
}
function getUrlQueryString(name) {
    let search = window.location.href.split('#')[0].split('?')[1];
    if (!search) {
      return null;
    }
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let value = search.match(reg);
    if (value != null) {
      return unescape(value[2]);
    } else {
      return null;
    }
}
const replaceString = (str) => {
  const specialStr = [/\|/g,/\//g, /\\/g, /;/g, /&/g]

  const replaceStr = ['-sx-','-xx-','-shxx-','-fh-','-and-']

  if(isArray(str)){
    for(let i=0;i<str.length;i++){
      for(let j=0;j<specialStr.length;j++){
        str[i]=str[i].replace(specialStr[j],replaceStr[j])
      }
    }
  }else{
    for(let i=0;i<specialStr.length;i++){
      str=str.replace(specialStr[i],replaceStr[i])
    }
  }

  return str
  //console.log(str)
}
const replaceFormat = (str) => {
  const specialStr = [/{/g,/}/g, /,/g, />/g, /\/>/g]

  const replaceStr = ['{\n','\n}\n',',\n','>\n','/>\n']

  if(isArray(str)){
    for(let i=0;i<str.length;i++){
      for(let j=0;j<specialStr.length;j++){
        str[i]=str[i].replace(specialStr[j],replaceStr[j])
      }
    }
  }else{
    for(let i=0;i<specialStr.length;i++){
      str=str.replace(specialStr[i],replaceStr[i])
    }
  }

  return str
  //console.log(str)
}

/**
 * 根据传入的数据，返回对应数据的类型
 * @param {any} data
 */
export const getDataType = (data) => {
  let type = ''
  // eslint-disable-next-line default-case
  switch (true) {
    case typeof data === 'boolean':
      type = 'boolean'
      break
    case typeof data === 'number':
      type = 'number'
      break
    case typeof data === 'string':
      type = 'string'
      break
    case data instanceof Array:
      type = 'array'
      break
    case data instanceof Object:
      type = 'object'
      break
    case typeof data === 'function':
      type = 'function'
      break
    case typeof data === 'undefined':
      type = 'undefined'
      break
    case data === null:
      type = 'null'
      break
  }
  return type
}

export const JSONStringPath = (obj) => {
  if (!obj) {
    return []
  }
  const getPath = (pPath, key) => {
    let path = pPath + (pPath ? '.' : '') + key
    return path ? '#{RESULT}.' + path : ''
  }
  let isArrObjPath = ''
  const tempDataPathsList = []
  const keyList = []
  const arrList = []
  const ergodic = (obj, pPath = '') => {
    const keys = Object.keys(obj)
    keys && keys.forEach(key => {
      let isStrArr = false
      try {
        isStrArr = getDataType(JSON.parse(obj[key])) === 'array'
      } catch (e) {
        isStrArr = false
      }
      // 找到存在数据的对象
      if (getDataType(obj[key]) === 'array' || isStrArr) {
        isArrObjPath = getPath(pPath, key)
        // 添加存在数据的key列表
        for (const subKey in obj[key][0]) {
          const path = isArrObjPath + (isArrObjPath ? '.' : '') + subKey
          arrList.push({
            name: subKey,
            key: path,
            value: path,
            label: path,
            path: path
          })
        }
        let path = getPath(pPath, key)
        tempDataPathsList.push({
          key: path,
          value: path,
          label: path,
          used: false,
          isArr: isArrObjPath === path
        })
      }
      const path = getPath(pPath, key)
      if (path) {
        // 添加没有数组对象的key列表
        keyList.push({
          key: path,
          value: path,
          label: path,
          used: false
        })
      }
      if (getDataType(obj[key]) === 'object') {
        const path = pPath + (pPath ? '.' : '') + key
        ergodic(obj[key], path, false)
      }
    })
  }
  ergodic(obj)
  return {
    tempDataPathsList: tempDataPathsList,
    keyList: keyList.filter(item => !item.value.includes(isArrObjPath)),
    arrList: arrList
  }
}
// 去重
export const removeDuplicate = (array) => {
  let keysList = []
  let result = []
  if (array.length === 0) { return array }
  keysList.push(array[0].key)
  result.push(array[0])
  for (let i = 1, len = array.length; i < len; i++) {
    if (!keysList.includes(array[i].key)) {
      keysList.push(array[i].key)
      result.push(array[i])
    }
  }
  return result
}
/** 读取数据的后端Java类型 */
export const getJavaDataType = (data) => {
  const typeObj = {
    boolean: 'BOOLEAN',
    number: 'NUMBER',
    string: 'STRING',
    object: 'STRUCT',
    array: 'ARRAY'
  }
  const type = typeObj[getDataType(data)] || 'STRING'
  return {
    fieldType: type,
    format: null,
    length: type === 'STRING' && data ? data.length : null,
    arrayType: type === 'ARRAY' ? typeObj[getDataType(data[0])] || 'STRING' : null
  }
}
export const fetchSourceType = (path) => {
  const pathList = path.split('.')
  if (pathList.length > 1) {
    if (pathList[0] === '#{RESULT}') {
      return 'Result'
    }
    if (pathList[0] === '#{PARAMETER}') {
      return 'Parameter'
    }
  }
  return 'FixedValue'
}
// 获取一级子集路径下子类
const getJavaDataChildren = (data, path, name) => {
  const type = getDataType(data)
  const arr = []
  if (type === 'array') {
    return getJavaDataChildren(data[0], path, name)
  } else if (type === 'object') {
    Object.keys(data).forEach(key => {
      const originalPath = path + '.' + key
      const newPath = name + '.' + key
      arr.push({
        name: key,
        path: newPath,
        originalPath: originalPath,
        ...getJavaDataType(data[key]),
        format: null,
        children: getJavaDataChildren(data[key], originalPath, newPath)
      })
    })
    return arr
  }
  return null
}
// 根据路径查找一级子集的路径
export const getObjChildPath = (obj, path) => {
  if (!obj || !path) return []
  const keys = path.split('.')
  if (keys.length < 1) return []
  let newObj = obj
  // 遍历读取指定路径对象
  keys.some(key => {
    newObj = key.includes('#{RESULT}') ? newObj : newObj[key]
    return !newObj
  })
  let pathsList = []
  const getArrList = (_newObj) => {
    return Object.keys(_newObj).map(key => {
      const newPath = path + '.' + key
      return {
        name: key,
        key: newPath,
        value: newPath,
        path: newPath,
        ...getJavaDataType(_newObj[key]),
        children: getJavaDataChildren(_newObj[key], newPath, key)
      }
    })
  }
  // eslint-disable-next-line default-case
  switch (getDataType(newObj)) {
    // 情况1 map
    case 'object':
      pathsList = getArrList(newObj)
      break
    case 'array':
      if (newObj[0]) {
        // 情况2 List Map
        if (getDataType(newObj[0]) === 'object') {
          pathsList = getArrList(newObj[0])
        } else {
          // 情况3 List
          pathsList = getArrList(newObj)
        }
      }
      break
  }
  return pathsList
}
export { alertMessage,
  auth, dateUtil, downloadFile,
  http,getQueryVariable,getUrlQueryString,
  replaceString,replaceFormat };
